import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { environment } from '../app/environments/environment';

import { TokenRefresh } from './token-refresh';
import { TokenStorage } from './token-storage';
import { TokenVerify } from './token-verify';

interface IAuthResponse {
  token: string;
}

interface IAuthCredentials {
  username: string;
  password: string;
}

interface ITokenAuthCredentials {
  token: string;
}

/*
  Generated class for the Authentication provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Authentication {
  private apiBaseUrl = environment.api_url;
  private verifyRefreshCycle;
  private verifyRefreshCycleSeconds = 15;

  constructor(
    public http: Http,
    private tokenRefresh: TokenRefresh,
    private tokenStorage: TokenStorage,
    private tokenVerify: TokenVerify) {
    console.log('Hello Authentication Provider');
  }

  getToken(): string {
    return this.tokenStorage.getToken();
  }

  setToken(token: string): void {
    return this.tokenStorage.setToken(token);
  }

  removeToken(): void {
    this.setToken('');
    return this.tokenStorage.removeToken();
  }

  /*
   * Returns true if authenticated, false otherwise.
   */
  isAuthenticated(): Observable<boolean> {
    console.log('Is authenticated?');

    let credentials = { token: this.getToken() };

    if (credentials.token === null) {
      return Observable.create(() => {
        console.log('Token verify failed');
        console.log('There is no token');
        return false;
      });
    } else {
      return this.verifyToken();
    }
  }

  login(credentials: IAuthCredentials): Observable<boolean> {
    let url = `${this.apiBaseUrl}api/token-auth/`;
    return this.http.post(url, credentials)
      .map(
        (response: Response) => {
          console.log(response);
          if (response.ok) {
            this.loginSuccess(response.json());
            return true;
          } else {
            console.error(response);
            return false;
          }
        }
      );
  }

  loginWithToken(credentials: ITokenAuthCredentials): Observable<boolean> {
    let url = `${this.apiBaseUrl}api/token-verify/`;
    return this.http.post(url, credentials)
      .map(
        (response: Response) => {
          console.log(response);
          if (response.ok) {
            this.loginSuccess(credentials);
            // this.refreshToken();
            return true;
          } else {
            console.error(response);
            return false;
          }
        }
      );
  }

  logout(): void {
    this.cancelVerifyRefreshCycle();
    return this.removeToken();
  }

  loginSuccess(data: IAuthResponse) {
    console.log('Login Success!', data);
    this.setToken(data.token);
    this.setVerifyRefreshCycle();
  }

  verifyToken(): Observable<boolean> {
    return this.tokenVerify.verify({ token: this.getToken() });
  }

  refreshToken(): Observable<string> {
    return this.tokenRefresh.refresh({ token: this.getToken() })
      .map(token => {
        if (token) { this.setToken(token); }
        return token;
      });
  }

  setVerifyRefreshCycle() {
    if (this.verifyRefreshCycle) {
      this.cancelVerifyRefreshCycle();
      return this.setVerifyRefreshCycle();
    }
    console.log('Starting verify-refresh cycle');
    let intervalSeconds = this.verifyRefreshCycleSeconds;
    let interval = setInterval(() => { return this.performVerifyRefreshCycle(); }, intervalSeconds * 1000);
    this.verifyRefreshCycle = interval;
  }

  performVerifyRefreshCycle() {
    this.verifyToken().first().subscribe(result => {
      if (result) { this.refreshToken().first().subscribe(); }
    });
  }

  cancelVerifyRefreshCycle() {
    console.log('Canceling verify-refresh cycle');
    this.verifyRefreshCycle = clearInterval(this.verifyRefreshCycle);
  }

}



// WEBPACK FOOTER //
// ./src/providers/authentication.ts